// useVoiceAssistant.js
import { useState, useCallback } from 'react';

export const useVoiceAssistant = () => {
  const [isVoiceAssistantOpen, setIsVoiceAssistantOpen] = useState(false);

  const openVoiceAssistant = useCallback(() => {
    setIsVoiceAssistantOpen(true);
  }, []);

  const closeVoiceAssistant = useCallback(() => {
    setIsVoiceAssistantOpen(false);
  }, []);

  const handleVoiceCommand = useCallback((command) => {
    console.log('Voice command received:', command);
    
    // Handle different voice commands
    switch (command) {
      case 'open-mentor':
        // This will be handled by the parent component
        return { type: 'open-mentor' };
      
      case 'open-video':
        return { type: 'open-video' };
      
      case 'open-resources':
        return { type: 'open-resources' };
      
      case 'open-submit':
        return { type: 'open-submit' };
      
      case 'open-feedback':
        return { type: 'open-feedback' };
      
      case 'open-visualize':
        return { type: 'open-visualize' };
      
      case 'start-task':
        return { type: 'start-task' };
      
      case 'next-task':
        return { type: 'next-task' };
      
      case 'previous-task':
        return { type: 'previous-task' };
      
      case 'complete-task':
        return { type: 'complete-task' };
      
      case 'submit-work':
        return { type: 'submit-work' };
      
      case 'get-help':
        return { type: 'get-help' };
      
      case 'explain-current':
        return { type: 'explain-current' };
      
      default:
        return { type: 'unknown', command };
    }
  }, []);

  const handleVoiceNavigation = useCallback((path) => {
    console.log('Voice navigation to:', path);
    // This will be handled by the parent component
    return { type: 'navigate', path };
  }, []);

  return {
    isVoiceAssistantOpen,
    openVoiceAssistant,
    closeVoiceAssistant,
    handleVoiceCommand,
    handleVoiceNavigation
  };
};









